/**
 * Calls the BFF `startTask` mutation once an outbound STL call connects and
 * PCS returns the conversation. Associates the task record in Task Hub with the
 * interaction (via channelId = PCS conversation sid) and transitions sys.status
 * to in_progress. The PCS conversation sid corresponds to the interaction
 * document's channel id.
 *
 * This is fire-and-forget — the dial is not blocked by the mutation outcome.
 * Failure is logged silently; the task remains functional regardless.
 */
import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { StartOutboundLeadTaskMutationVariables } from '@api/generated/graphql';

export const START_OUTBOUND_LEAD_TASK_MUTATION = graphql(`
  mutation StartOutboundLeadTask(
    $tenantId: ID!
    $taskId: ID!
    $channelId: ID!
  ) {
    startOutboundLeadTask(
      tenantId: $tenantId
      taskId: $taskId
      channelId: $channelId
    )
  }
`);

export const startTask = async (
  variables: StartOutboundLeadTaskMutationVariables,
): Promise<boolean> => {
  const { data } = await getClient().mutate({
    mutation: START_OUTBOUND_LEAD_TASK_MUTATION,
    variables,
  });

  return data?.startOutboundLeadTask ?? false;
};
